<template>
  <Authenticated>
    <div class="product">
      <CartColumn />
      <section class="content">
        <div v-if="!productFromRoute" class="loading">
          <p>Loading product...</p>
        </div>

        <div v-else id="product_header">
          <div class="title">
            <font-awesome-icon class="backwards" icon="backward" @click.stop.prevent="$router.go(-1)"></font-awesome-icon>
            <span class="subtitle">
              <h2>{{ productFromRoute.name }}</h2>
              <h2><CurrencyFormatter :value="productFromRoute.price + modifierPrices" :currency="currency"/></h2>
            </span>
            <span class="desc" v-html="productFromRoute.description"></span>
            <span>{{ dietary }}</span>
            <div class="allergens-section">
              <div class="allergen-header" @click="toggleAllergens">
                <span>Allergens ({{ allAllergens.length }})</span>
                <font-awesome-icon :icon="showAllergens ? 'chevron-up' : 'chevron-down'" class="chevron-icon" />
              </div>
              <transition name="slide-down">
                <div v-if="showAllergens" class="allergen-list">
                  <div v-for="allergen in allAllergens" :key="allergen" class="allergen-item">
                    <p>{{ allergen }}</p>
                  </div>
                </div>
              </transition>
            </div>
            <div class="nutritonal-section">
            
           <div class="nutritonal-header" @click="toggleAllergens">
                <span>nutritonal information</span>
                
              </div>
              <transition name="slide-down">
                <div class="nutritonal-list">
                  <div class="nutritonal-item">
                    <p></p>
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <div v-if="productFromRoute.images" class="images">
            <img v-for="image in productFromRoute.images.slice(0, 4)" :key="image" :src="image" />
          </div>
          <button
            :disabled="!valid"
            :class="(!valid ? 'non-selectable' : 'action-colour') + ' addToCart fr'"
            @click="
              addToCartWrapper({
                id: productFromRoute._id,
                modifiers: selectedModifiersSets,
                price: productFromRoute.price,
              })
            ">
            <font-awesome-icon icon="plus" />
            Add to Cart
          </button>
        </div>
        <div class="modifers-container" v-if="productFromRoute && selectedModifiersSets">
          <div v-if="showValidations">
            <ul :key="validation.name" v-for="validation in validations">
              <li :key="validation.name + '-' + rule.name" v-for="rule in validation.value">
                <span>{{ rule.name }} - {{ rule.value }}</span>
              </li>
            </ul>
          </div>
          <div>
            <ul class="modifiers" v-bind:key="modifier_set" v-for="modifier_set in modifier_sets">
              <div class="modifier-heading">
                <h3>{{ modifier_set.name }}</h3>
                <h4 class="warning" v-if="modifier_set.rules.required && !valid">Required*</h4>
                <router-link v-if="!getKiosk" class="quantity-link" :to="`/modifiers/${modifier_set._id.replace(/^.*:/, '')}`"><button>Update Modifiers</button></router-link>
              </div>
              <div class="modifiers-layout" v-if="!productFromRoute.overrideOneMod">
                <ItemModalButton
                  :modifier="modifier"
                  :selectedModifiersSets="selectedModifiersSets"
                  :modifierSet="modifier_set"
                  @addModifier="addModifier"
                  v-bind:key="modifier"
                  v-for="modifier in modifier_set.modifiers.filter((mod) => mod.active)" />
              </div>
              <div class="modifiers-layout" v-if="productFromRoute.overrideOneMod">
                <ItemQuantitySetter
                  :modifier="modifier"
                  :selectedModifiersSets="selectedModifiersSets"
                  :modifierSet="modifier_set"
                  @addModifier="addModifier"
                  @addOverrideMod="addOverrideMod"
                  @removeOverrideMod="removeOverrideMod"
                  v-bind:key="modifier"
                  v-for="modifier in modifier_set.modifiers.filter((mod) => mod.active)" />
              </div>
            </ul>
            <span style="height: 100px"></span>
          </div>
        </div>
      </section>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "@/components/_layouts/Authenticated.vue";
import ItemModalButton from "@/components/Store/ItemModalButton.vue";
import ItemQuantitySetter from "@/components/Store/ItemQuantitySetter.vue";
import CartColumn from "./CartColumn.vue";
import { mapActions } from "vuex";
import { reactive } from "vue";
import { mapGetters } from "vuex";
import { CurrencyFormatter } from "@monolith/components";

export default {
  name: "ItemPage",
  components: { ItemModalButton, ItemQuantitySetter, Authenticated, CartColumn, CurrencyFormatter},
  data() {
    return {
      valid: false,
      validations: [],
      showValidations: false,
      quantity: 1,
      renderComponent: true,
      modifierPrices: 0,
      productLoaded: {},
      allAllergens: [],
      showAllergens: false,
      dietary: "hi",
    };
  },
  methods: {
    combinedAllergens() {
      let a = [];
      if ("allergens" in this.productFromRoute) {
        this.productFromRoute.allergens.map((allergen) => (allergen.contains ? a.push(allergen.name) : null));
      }
      if (this.selectedModifiersSets) {
        for (let set in this.selectedModifiersSets) {
          for (let mod in this.selectedModifiersSets[set]) {
            if ("allergens" in this.selectedModifiersSets[set][mod]) {
              this.selectedModifiersSets[set][mod].allergens.map((allergen) => {
                if (allergen.contains) {
                  a.push(allergen.name);
                }
              });
            }
          }
        }
      }
      this.allAllergens = Array.from(new Set(a));
    },

    toggleAllergens() {
      this.showAllergens = !this.showAllergens;
    },

    async addToCartWrapper(product) {
      /* first remove the existing item */
      this.selectedModifiersSets = {};

      if (Object.keys(product.modifiers).length == 0) {
        this.addToCart(product);
        this.$router.push("/store");
        return;
      }
      if (this.lineItem) {
        await this.changeLineItemQuantity({
          productHash: this.lineItem.hash,
          delta: -1,
        });
        product.hash = this.lineItem.hash;
      }
      this.addToCart(product);

      this.$notify({
        text: "Item added to cart",
        type: "success",
        duration: 1500,
      });

      if (product.modifiers && Object.keys(product.modifiers).length > 0) {
        this.changeCartDelta(product, 1);
      }
      this.$router.push("/store");
    },
    forceRerender() {
      // Removing my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Adding the component back in
        this.renderComponent = true;
      });
    },
    changeCartDelta(currentProduct, delta) {
      Object.keys(currentProduct.modifiers).forEach((modifierset) => {
        let foundModifierSet = this.modifier_sets.find((m) => m._id === modifierset);
        if (foundModifierSet && foundModifierSet.rules) {
          if (foundModifierSet.rules.inventory) {
            /* send to web socket */
            currentProduct.modifiers[modifierset].forEach((modifierDeltaChange) => {
              this.channel.push("modifier:set:delta", {
                modifierset: modifierset,
                modifier: modifierDeltaChange,
                delta: delta * -1,
              });
            });
          }
        }
      });
    },
    calculatePrice() {
      this.modifierPrices = 0;
      for (let set in this.selectedModifiersSets) {
        for (let mod in this.selectedModifiersSets[set]) {
          this.modifierPrices += this.selectedModifiersSets[set][mod].price;
        }
      }
    },
    ...mapActions(["addToCart", "changeLineItemQuantity"]),
    validation() {
      this.combinedAllergens();

      /* validations should be an array where every value is 'true' */

      /* every value, represents a modifier set, but they themselves solve be an array, because a single modifier set may have multiple */
      /* validations required and 'all' must be true */
      if (!this.modifier_sets) {
        return;
      }

      if (this.productFromRoute.overrideOneMod) {
        this.valid = true;
        return;
      }
      this.validations = this.modifier_sets.map((set) => {
        let set_validations = [];

        /* is this modifier set 'required' */
        if (set && set.rules && set.rules.required) {
          if (set._id in this.selectedModifiersSets) {
            /* do we have an object in this set meeting the 'required' requirement */
            if (this.selectedModifiersSets[set._id] && this.selectedModifiersSets[set._id].length > 0) {
              set_validations.push({ name: "required", value: true });
            } else {
              set_validations.push({ name: "required", value: false });
            }
          } else {
            set_validations.push({ name: "required", value: false });
          }
        }

        /* is this modifier set 'one-only', e.g. bagel-type */
        if (set && set.rules && set.rules.oneonly) {
          if (set._id in this.selectedModifiersSets) {
            /* do we have an object in this set meeting the 'required requirement */
            if (this.selectedModifiersSets[set._id] && this.selectedModifiersSets[set._id].length === 1) {
              set_validations.push({ name: "oneonly", value: true });
            } else {
              set_validations.push({ name: "oneonly", value: false });
            }
          }
          // else {
          //   set_validations.push({name: 'oneonly', value: false});
          // }
        }

        /* this is test code where inventory is being used as a must include minimum of (e.g. 3 requirements) */

        if (set && set.rules && set.rules.inventory) {
          set_validations.push({ name: "inventory", value: true });

          // if ( ( set._id in this.selectedModifiersSets ) ) {
          //   /* do we have an object in this set meeting the 'requivar(--warning-colour)' requirement */
          //   if ( this.selectedModifiersSets[set._id].length >= 5 ) {
          //     set_validations.push({name: 'inventory', value: true});
          //   }
          //   else {
          //     set_validations.push({name: 'inventory', value: false});
          //   }
          // }
          // else {
          //   set_validations.push({name: 'inventory', value: false});
          // }
        }
        //
        /*** no defined rules - therefore validation passes ***/

        if (set && set.rules) {
          set_validations.push({ name: "no-rules", value: true });
        }

        return { name: set._id, value: set_validations };
      });
      if (this.validations.length === 0) {
        this.valid = true;
      } else {
        //this.showValidations = true;
        let all_valid = this.validations.every((set) => {
          /* fail the rule if a single modifier returns false (or is empty) - the logic rules should always be true if the rules are optional */
          if (set.value.length === 0) {
            return false;
          }

          return set.value.every((rule) => {
            return rule.value === true;
          });
        });

        this.valid = all_valid;
      }
    },
    addOverrideMod(v) {
      const modifier = { ...v.modifier };
      let modifier_set = v.modifier_set;
      if (!this.selectedModifiersSets[modifier_set._id]) {
        this.selectedModifiersSets[modifier_set._id] = [];
      }
      this.selectedModifiersSets[modifier_set._id].length == 0 ? (modifier.price = v.modifier.price) : (modifier.price = this.productLoaded.price + v.modifier.price);
      this.selectedModifiersSets[modifier_set._id].push({ ...modifier });
      this.calculatePrice();
    },
    removeOverrideMod(v) {
      let modifier = v.modifier;
      let modifier_set = v.modifier_set;
      this.selectedModifiersSets[modifier_set._id].pop(modifier);
      this.calculatePrice();
    },
    addModifier(v) {
      let modifier = v.modifier.name;
      let modifier_set = v.modifier_set;
      let selected = v.selected;
      if (modifier_set.rules.oneonly && this.selectedModifiersSets[modifier_set._id]) {
        for (var mod in this.selectedModifiersSets) {
          if (mod === modifier_set._id) {
            this.selectedModifiersSets[mod] = [];
          }
        }
        this.forceRerender();
      }

      if (selected) {
        if (!(modifier_set._id in this.selectedModifiersSets)) {
          this.selectedModifiersSets[modifier_set._id] = [];
        }

        /* toggle */
        if (
          this.selectedModifiersSets[modifier_set._id].find((m) => {
            return m.name === modifier;
          })
        ) {
          this.selectedModifiersSets[modifier_set._id] = this.selectedModifiersSets[modifier_set._id].filter((mod) => {
            return modifier !== mod;
          });
        } else {
          this.selectedModifiersSets[modifier_set._id].push(v.modifier);
        }
      } else {
        if (this.selectedModifiersSets[modifier_set._id].find((m) => m.name === modifier)) {
          this.selectedModifiersSets[modifier_set._id] = this.selectedModifiersSets[modifier_set._id].filter((mod) => {
            return modifier !== mod.name;
          });
        }
      }

      this.modifierPrices = 0;
      this.calculatePrice();
      this.validation();
    },
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getKiosk: "getKiosk",
      categories: "categories",
      allProducts: "allProducts",
      active_products_in_categories: "active_products_in_categories",
      currency: "currency",
      /* we want all modifier sets (full doc) - there is an es6 function that does this - what is it? */
    }),

    productFromRoute() {
      const categorySlug = this.$route.params.category;
      const productSlug = this.$route.params.product;

      if (!categorySlug || !productSlug) return null;

      const categoryId = "category:" + categorySlug;
      const category = this.categories.find((cat) => cat.id === categoryId);

      if (!category) return null;

      const products = this.active_products_in_categories(category);
      const productId = "product:" + productSlug;
      const product = products.find((prod) => prod.value._id === productId);

      return product ? product.value : null;
    },

    modifier_sets() {
      const product = this.productFromRoute;
      if (!product) {
        return [];
      }

      let sets = [...product.modifiersets];
      let modifier_sets_docs = this.$store.getters.modifiers(sets);

      return modifier_sets_docs.sort((a) => {
        if (a && a.rules && a.rules.required) {
          return -1;
        }
        return 0;
      });
    },
  },
  setup() {
    const selectedModifiersSets = reactive({});

    return {
      selectedModifiersSets,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(newRoute) {
        if (!newRoute.params.category || !newRoute.params.product) {
          this.$router.push("/store");
        }

        this.$nextTick(() => {
          if (!this.productFromRoute) {
            this.$router.push("/store");
          }
        });
      },
    },

    productFromRoute: {
      immediate: true,
      handler(product) {
        if (!product) return;

        if (this.modifier_sets.length === 0) {
          this.addToCartWrapper({
            id: product._id,
            modifiers: this.selectedModifiersSets,
            price: product.price,
          });
          return;
        }

        this.productLoaded = { ...product };
        this.modifierPrices = 0;
        this.valid = false;
        this.validation();
      },
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.product {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  max-height: 100%;
  width: 100%;
  background-color: var(--primary-colour);

  :deep(.parent) {
    position: fixed;
    right: 0;
  }

  .content {
    flex: 1;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-width: 73%;
  }

  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;

    p {
      color: var(--text-colour);
      font-size: 1.1rem;
    }
  }
}

.backwards {
  cursor: pointer;
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  color: var(--action-colour);
}

#product_header {
  display: flex;
  margin: 0.25rem;
  background: var(--secondary-colour);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .title {
    flex: 1;
    padding-right: 1rem;

    .subtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;

      h2 {
        margin: 0;
        color: var(--text-colour);

        &:last-child {
          color: var(--action-colour);
          font-weight: bold;
        }
      }
    }

    .desc {
      color: var(--text-colour);
      margin-bottom: 1rem;
      line-height: 1.5;
    }

    h3 {
      color: var(--text-colour);
      margin: 1rem 0 0.5rem 0;
      font-size: 1.1rem;
    }

    p {
      margin: 0.25rem 0;
      color: var(--text-colour);
    }
  }

  .images {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    max-width: 200px;

    img {
      width: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
  }
  .addToCart {
    position: sticky;
    bottom: 2rem;
    background-color: var(--action-colour);
    color: white;
    border: none;
    padding: 1rem 2rem;
    border-radius: 8px;
    font-size: 1.1rem;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background-color: color-mix(in srgb, var(--action-colour) 90%, black 10%);
      transform: translateY(-1px);
    }

    &.non-selectable {
      background-color: #ccc !important;
      color: #666;
      cursor: not-allowed;
      opacity: 0.6;

      &:hover {
        transform: none;
      }
    }
  }
}

.modifiers {
  background: var(--secondary-colour);
  border-radius: 8px;
  padding: 0.5rem 1rem;
  margin: 0.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .modifier-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 2.5rem;

    h3 {
      margin: 0;
      color: var(--text-colour);
    }

    .warning {
      color: var(--warning-colour);
      font-size: 0.9rem;
      margin: 0;
    }

    .quantity-link button {
      padding: 0.25rem 0.5rem;
      background-color: var(--secondary-colour);
      color: var(--text-colour);
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: pointer;
      font-size: 0.9rem;

      &:hover {
        background-color: var(--action-colour);
        color: white;
      }
    }
  }

  .modifiers-layout {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.5rem;
  }
}

.allergens-section {
  margin-top: 1rem;

  .allergen-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 0.75rem;
    background-color: rgba(255, 193, 7, 0.1);
    border-radius: 6px;
    transition: all 0.2s ease;
    margin: 0;

    &:hover {
      background-color: rgba(255, 193, 7, 0.15);
    }

    span {
      color: var(--warning-colour);
      font-weight: 600;
      font-size: 1rem;
    }

    .chevron-icon {
      color: var(--warning-colour);
      font-size: 0.9rem;
      transition: transform 0.2s ease;
    }
  }

  .allergen-list {
    padding: 0.5rem 0 0 0;
    margin-left: 1rem;

    .allergen-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.5rem;
      padding: 0.5rem;
      background-color: rgba(255, 193, 7, 0.05);
      border-radius: 4px;

      .warning-icon {
        color: var(--warning-colour);
        font-size: 0.8rem;
        flex-shrink: 0;
      }

      p {
        margin: 0;
        color: var(--text-colour);
        font-size: 0.9rem;
      }
    }
  }
}

// Slide down animation
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.slide-down-enter-from,
.slide-down-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}

.slide-down-enter-to,
.slide-down-leave-from {
  max-height: 300px;
  opacity: 1;
  transform: translateY(0);
}

// Mobile styles
@media only screen and (orientation: portrait) {
  .product {
    flex-direction: column;
    height: auto;

    .content {
      padding: 1rem;
    }
  }

  #product_header {
    flex-direction: column;

    .images {
      max-width: none;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .modifiers .modifiers-layout {
    grid-template-columns: 1fr;
  }

  .addToCart {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    margin: 0;
    width: calc(100% - 2rem);
    justify-content: center;
  }
}
</style>
